import React, { Component } from 'react';
import ReactSVG from "react-svg";

class DetailsGroup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            visible: true
        }
    }

    toggleItems = () => {
        const { visible } = this.state

        this.setState({
            visible: !visible
        })
    }


    render() {
        const { name, hiddenable, highlight, disabledStyle } = this.props;
        const { visible } = this.state;
        return (
            <div className={`details-group ${highlight ? "highlight-group " : ""} ${disabledStyle ? "details-group--disabled" : ""}`}>
                {
                    name &&
                        <div className={"details-group__header " + (hiddenable ? "details-group__header--pointer " : " ") + (visible ? " " : "details-group__header--items-hidden ")} onClick={hiddenable ? this.toggleItems : null}>
                            <span>{name}</span>
                            {
                                hiddenable &&
                                this.props.children.length > 1
                                &&
                                    <div className="header__icon">
                                        <ReactSVG src="/css/img/right-pink.svg " />
                                    </div>
                            }
                        </div>
                }

                <div className={"details-items " + (visible ? "details-items--visible " : "details-items--hidden ")}>
                    { this.props.children }
                </div>
            </div>
        )
    }
}

export default DetailsGroup;
